// extracted by mini-css-extract-plugin
export var black = "_3e-6";
export var brand = "_3e-1";
export var ddefault = "_3e-0";
export var error = "_3e-3";
export var gray = "_3e-2";
export var highContrast = "_3e-8";
export var outline = "_3e-7";
export var success = "_3e-5";
export var warning = "_3e-4";